import { useEffect, useRef } from "react"
import ScrollReveal from "scrollreveal"
import styles from "./FifthScreen.module.css"

import Button from "../components/button/Button"
import Shorts from "../components/shorts/Shorts"
import image1 from "../images/לפני אחרי קיר.webp"
import image2 from "../images/לפני אחרי 2.webp"
import image3 from "../images/מיתוג פילאטיס.webp"

const FifthScreen = () => {
  const image1Ref = useRef(null)
  const image2Ref = useRef(null)
  const image3Ref = useRef(null)

  useEffect(() => {
    const sr = ScrollReveal({
      origin: 'top',
      distance: '60px',
      duration: 1000,
      delay: 200,
      opacity: 0,
      easing: 'ease-in-out',
      reset: false
    })

    if (image3Ref.current) {
      sr.reveal(image3Ref.current, { delay: 200 })
    }
    if (image1Ref.current) {
      sr.reveal(image1Ref.current, { delay: 400 })
    }
    if (image2Ref.current) {
      sr.reveal(image2Ref.current, { delay: 600 })
    }

    return () => {
      sr.destroy()
    }
  }, [])

  return <>
    <div className={styles.title}>
      משוויצה קצת במה שאני
      <div className={styles.titleHighlight}>מוציאה מכם</div>
    </div>
  
    <Shorts/>
           
    <Button text="נטלי, אני רוצה להפוך את העסק למותג!"/>
    
    <div className={styles.title}>
      קצת
      <div className={styles.titleHighlight}>מהפכים</div>
    </div>
    
    <div className={styles.imageContainer} ref={image3Ref}>
      <img className={styles.image} src={image3} alt="מיתוג פילאטיס"/>
    </div>
    
    <div className={styles.imageContainer} ref={image1Ref}>
      <img className={styles.image} src={image1} alt="לפני אחרי קיר"/>
    </div>
    
    <div className={styles.imageContainer} ref={image2Ref}>
      <img className={styles.image} src={image2} alt="לפני אחרי"/>
    </div>
    
    <Button text="נטלי בואי נדבר על העסק שלי!"/>
  </>
}

export default FifthScreen